export default __webpack_public_path__ + "static/media/delete.939e6451.svg";